import {useState} from "react";
import { Drawer } from "shared/ui/drawer"
import {
  ProfileDrawerWrapper,
  ProfileDrawerContent,
  HLine,
  ProfileDrawerHeader,
  ProfileDrawerTitle,
  ProfileContentWrapper,
  HLineLight,
  ProfileDrawerFooter, ProfileEditorForm,
} from "../styles.ts";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import {CloseIcon} from "shared/ui/icons";
import {toRem} from "shared/helpers";
import {useResize} from "../../../../app/lib/hooks/useResize.ts";
import {ProfileHeader} from "widgets/profile/ui/ui/ProfileHeader.tsx";
import {ProfileInfo} from "widgets/profile/ui/ProfileSection/ProfileInfo.tsx";
import {ProfileInfoControls} from "widgets/profile/ui/ui/ProfileInfoControls.tsx";
import {useEditProfile} from "widgets/profile/lib/useEditProfile.ts";
import {Controller} from "react-hook-form";
import {Input, InputDate} from "@atomaro/ui-kit";
import {withMask} from "use-mask-input";
import {SuggestionsList} from "shared/ui/suggestionsList";

type ProfileDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const ProfileDrawer = ({ isOpen, onClose }: ProfileDrawerProps) => {
  const { isScreenMd } = useResize();
  const [showEditor, changeShowEditor] = useState(false)
  
  const {
    control,
    errors,
    emailPattern,
    changeFirstName,
    changeLastName,
    changePatronymic,
    changeBirthDay,
    changeEmail,
    changeCity,
    dataValues,
    showSuggestions,
    onSuggestionClick,
    registerWithMask,
    phoneMask,
    handleSubmit,
    onPersDataSubmit,
    isDirty,
    isLoading,
    reset
  } = useEditProfile({})
  
  const onReset = () => {
    changeShowEditor(false);
    reset();
  }
  
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      position="right"
    >
      <ProfileEditorForm
        onSubmit={handleSubmit(onPersDataSubmit)}
      >
      <ProfileDrawerWrapper>
        <ProfileDrawerHeader>
          <Button
            iconPrefix={<CloseIcon/>}
            variant="secondary"
            colorScheme="neutral"
            style={{alignSelf: 'flex-end', width: !isScreenMd ? toRem(24) : toRem(36)}}
            size={!isScreenMd ? 's' : 'm'}
            onClick={onClose}
          />
          <ProfileDrawerTitle>
            Личные данные
          </ProfileDrawerTitle>
          <HLine/>
        </ProfileDrawerHeader>
        
        <ProfileDrawerContent>
          
          <ProfileHeader />
          
          <ProfileContentWrapper>
            {showEditor
              ? (
                <>
                  <Controller
                    name="lastName"
                    control={control}
                    rules={{ required: 'Введите фамилию', maxLength: {value: 20, message: 'Максимум 20 символов'} }}
                    render={({field}) => (
                      <Input
                        name={field.name}
                        value={field.value}
                        style={{width: '100%', order: 0}}
                        size="l"
                        label="Фамилия"
                        variant={'primary'}
                        error={errors.lastName?.message}
                        onChange={event => changeLastName(event, field)}
                      />
                    )}
                  />
                  <Controller
                    name="firstName"
                    control={control}
                    rules={{ required: 'Введите имя', maxLength: {value: 20, message: 'Максимум 20 символов'} }}
                    render={({field}) => (
                      <Input
                        name={field.name}
                        value={field.value}
                        style={{width: '100%', order: 1}}
                        size="l"
                        label="Имя"
                        error={errors.firstName?.message}
                        onChange={event => changeFirstName(event, field)}
                      />
                    )}
                  />
                  <Controller
                    name="patronymic"
                    control={control}
                    rules={{ maxLength: {value: 20, message: 'Максимум 20 символов'} }}
                    render={({field}) => (
                      <Input
                        name={field.name}
                        value={field.value}
                        style={{width: '100%', order: 2}}
                        size="l"
                        label="Отчество"
                        error={errors.patronymic?.message}
                        onChange={event => changePatronymic(event, field)}
                      />
                    )}
                  />
                  
                  <Controller
                    name="birthday"
                    control={control}
                    rules={{required: 'Введите дату рождения'}}
                    render={({field}) => (
                      <InputDate
                        name={field.name}
                        activeDate={field.value}
                        style={{width: '100%', order: 3}}
                        size="l"
                        placeholder="Дата рождения"
                        onChange={date => changeBirthDay(date, field)}
                        autoComplete="off"
                        maxDate={new Date()}
                        maxYear={new Date().getFullYear()}
                        minYear={1900}
                        error={errors.birthday?.message}
                        ref={withMask('99.99.9999')}
                      />
                    )}
                  />
                  
                  <Controller
                    name="city"
                    control={control}
                    rules={{ required: 'Введите город', maxLength: {value: 30, message: 'Максимум 30 символов'} }}
                    render={({field}) => (
                      <div style={{width: '100%', position: 'relative'}}>
                        <SuggestionsList list={dataValues} isShow={showSuggestions} onClick={onSuggestionClick}/>
                        <Input
                          name={field.name}
                          value={field.value}
                          size="l"
                          label="Город"
                          error={errors.city?.message}
                          onChange={event => changeCity(event, field)}
                          autoComplete="off"
                        />
                      </div>
                    )}
                  />
                  
                  <Controller
                    name="email"
                    control={control}
                    rules={{ required: 'Введите e-mail', pattern: emailPattern.current }}
                    render={({field}) => (
                      <div style={{order: 5}}>
                        <Input
                          name={field.name}
                          value={field.value}
                          size="l"
                          label="Почта"
                          error={errors.email ? (errors.email?.type === 'pattern' ? 'Некорректный e-mai' : (errors.email?.message || 'Некорректный e-mai')) : undefined}
                          onChange={event => changeEmail(event, field)}
                          autoComplete="email"
                        />
                      </div>
                    )}
                  />
                  <Controller
                    name="login"
                    control={control}
                    render={({field}) => (
                      <div style={{order: 6}}>
                        <Input
                          {...registerWithMask('login', [phoneMask.current], {
                            // pattern: /^((\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/,
                          })}
                          disabled
                          name={field.name}
                          value={field.value}
                          autoComplete="tel"
                          size="l"
                          label="Номер телефона"
                        />
                      </div>
                    )}
                  />
                </>
              )
              : <ProfileInfo/>}
            <HLineLight/>
          </ProfileContentWrapper>
        </ProfileDrawerContent>
        
        <ProfileDrawerFooter>
          <HLine/>
          <ProfileInfoControls
            isDisabled={!isDirty || isLoading}
            showEditor={showEditor}
            onOpen={() => changeShowEditor(true)}
            onClose={onReset}
            onSubmit={() => {
              handleSubmit(onPersDataSubmit)
            }}
          />
        </ProfileDrawerFooter>
      </ProfileDrawerWrapper>
      </ProfileEditorForm>
    </Drawer>
  )
}